import { useRef, useEffect, useState } from "react"
import { useParams, useLocation } from "react-router-dom"
import ProductGroupAccordion, { ProductGroup } from '../../components/Products/ProductGroupAccordion'
import ManufacturerAccordion from '../../components/Products/ManufacturerAccordion'
import ProductTagList from '../../components/Products/ProductTagList'
import ProductsList, { Product } from "components/Products/ProductsList"
import RecommendationList from "components/Products/RecommendationList"
import FilterMobileDialog from "components/Products/FilterMobileDialog"
import { fetchProductList, fetchLastedProducts, ProductListParams } from "api/Product"
import { fetchProductList as fetchCustomProductList } from "api/Product_custom"
import { fetchProductCategoryList } from "api/ProductCategory"
import { fetchUserWishlistIds } from "api/Wishlist"
import { getProductManufacturerList, ProductManufacturerItem } from "api/ProductManufacturers"
import { getProductGroupList, ProductGroupItem } from "api/ProductGroup"
import ProductGroupListAccordion from "components/Products/ProductGroupListAccordion"
import { Helmet } from "react-helmet-async"

const SORT_OPTIONS = [
    {
        label: "Bán chạy nhất", value: "best_seller",
    },
    {
        label: "Mới nhất", value: "newest",
    },
    {
        label: "Giá thấp đến cao", value: "price_asc",
    },
    {
        label: "Giá cao đến thấp", value: "price_desc",
    }
]

export default function Dashboard() {
    const { category_slug } = useParams();
    const location = useLocation();
    const isLasted = location.pathname.includes('/lasted') || category_slug === 'lasted';
    const isHighProfit = location.pathname.includes('/highprofit') || category_slug === 'highprofit';

    const listRef = useRef<HTMLDivElement>(null)

    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(true)
    const [checked, setChecked] = useState(false)

    const [open, setOpen] = useState(false)
    const [SortValue, setSortValue] = useState("Bán chạy nhất")
    const wrapperRef = useRef<HTMLDivElement | null>(null)
    const [showFilter, setShowFilter] = useState(false)

    const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
    const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null)
    const [selectedManufacturer, setSelectedManufacturer] = useState<number | null>(null)
    const [selectedGroup, setSelectedGroup] = useState<number | null>(null)
    const [selectedGroupQueryId, setSelectedGroupQueryId] = useState<string | null>(null)

    const [list, setList] = useState<Product[]>([])
    const [productGroup, setProductGroup] = useState<ProductGroup[]>([])
    const [manufacturers, setManufacturers] = useState<ProductManufacturerItem[]>([])
    const [groups, setGroups] = useState<ProductGroupItem[]>([])
    const [wishlistIds, setWishlistIds] = useState<number[]>([])

    useEffect(() => {
        if (showFilter) {
            document.documentElement.style.overflow = "hidden"
            document.documentElement.style.height = "100%"

            document.body.style.overflow = "hidden"
            document.body.style.height = "100%"
            document.body.style.touchAction = "none"
        } else {
            document.documentElement.style.overflow = ""
            document.documentElement.style.height = ""

            document.body.style.overflow = ""
            document.body.style.height = ""
            document.body.style.touchAction = ""
        }

        return () => {
            document.documentElement.style.overflow = ""
            document.documentElement.style.height = ""
            document.body.style.overflow = ""
            document.body.style.height = ""
            document.body.style.touchAction = ""
        }
    }, [showFilter])

    const SCROLL_DISTANCE = 320

    const updateScrollState = () => {
        const el = listRef.current
        if (!el) return

        const { scrollLeft, scrollWidth, clientWidth } = el

        setCanScrollLeft(scrollLeft > 0)
        setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1)
    }

    const scrollLeft = () => {
        listRef.current?.scrollBy({
            left: -SCROLL_DISTANCE,
            behavior: "smooth",
        })
    }

    const scrollRight = () => {
        listRef.current?.scrollBy({
            left: SCROLL_DISTANCE,
            behavior: "smooth",
        })
    }

    useEffect(() => {
        updateScrollState()
    }, [])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const groupParam = searchParams.get("group")
        const categoryParam = searchParams.get("category")
        const parsedGroupId = groupParam ? Number(groupParam) : NaN
        const hasValidGroupParam = !Number.isNaN(parsedGroupId)

        setSelectedGroupQueryId(hasValidGroupParam ? groupParam : null)
        setSelectedGroup(hasValidGroupParam ? parsedGroupId : null)
        setSelectedCategoryId(categoryParam)

        if (categoryParam) {
            setSelectedCategory(null)
        }
    }, [location.search])

    const toggle = (e: React.MouseEvent) => {
        e.preventDefault() // 👈 QUAN TRỌNG
        setChecked((prev) => !prev)
    }

    const handleSelectCategory = (category: string | null) => {
        setSelectedCategoryId(null)
        setSelectedCategory(category)
    }

    const handleSelectGroup = (group: number | null) => {
        setSelectedGroupQueryId(null)
        setSelectedGroup(group)
    }

    const [limit, setLimit] = useState(12)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)

    const goPrev = () => {
        if (page > 1) setPage(page - 1)
    }

    const goNext = () => {
        if (page < totalPage) setPage(page + 1)
    }

    const getPages = () => {
        const pages: (number | string)[] = [];
        const maxPagesToShow = 5;

        if (totalPage <= 7) {
            for (let i = 1; i <= totalPage; i++) pages.push(i);
        } else {
            pages.push(1);
            if (page > 4) pages.push("...");

            const start = Math.max(2, page - 1);
            const end = Math.min(totalPage - 1, page + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (page < totalPage - 3) pages.push("...");
            pages.push(totalPage);
        }
        return pages;
    };

    useEffect(() => {
        const handlePointerDown = (e: PointerEvent) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target as Node)
            ) {
                setOpen(false)
            }
        }

        // 👇 capture = true → ăn trước mọi stopPropagation
        document.addEventListener("pointerdown", handlePointerDown, true)

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown, true)
        }
    }, [page])


    useEffect(() => {
        // Fetch product groups from API and map them correctly to handle hierarchy
        fetchProductCategoryList().then(response => {
            if (response.status && response.data?.items) {
                const allItems = response.data.items;
                const childIds = new Set<number>();

                // Identify all items that are children of another item to filter them from the root
                allItems.forEach(item => {
                    item.children?.forEach(child => childIds.add(child.id));
                });

                const groupsFromApi: ProductGroup[] = allItems
                    .filter(item => !childIds.has(item.id)) // Only keep root categories
                    .map(category => ({
                        id: category.slug,
                        label: category.name,
                        subs: category.children?.map(child => ({
                            id: child.slug,
                            label: child.name
                        }))
                    }));

                setProductGroup(groupsFromApi);
            }
        });

        getProductManufacturerList().then(items => setManufacturers(items));
        getProductGroupList().then(items => setGroups(items));

        const syncWishlist = async () => {
            const ids = await fetchUserWishlistIds();
            console.log(ids);
            setWishlistIds(ids);
        };
        syncWishlist();
    }, [])

    useEffect(() => {
        let sortParam: string[] = []
        switch (SortValue) {
            case "best_seller":
                sortParam = [];
                break;
            case "newest":
                sortParam = ["created_at,desc"];
                break;
            case "price_asc":
                sortParam = ["price,asc"];
                break;
            case "price_desc":
                sortParam = ["price,desc"];
                break;
            default:
                sortParam = [];
        }

        const fetchFn = isHighProfit
            ? () => fetchCustomProductList({ type: 1 })
            : (isLasted ? fetchLastedProducts : fetchProductList);

        const params: ProductListParams = {
            page,
            sort: sortParam,
            product_category_id: (!category_slug || category_slug === 'lasted' || category_slug === 'highprofit') ? (selectedCategoryId ?? undefined) : undefined,
            slug_category: (category_slug && category_slug !== 'lasted' && category_slug !== 'highprofit') ? category_slug : (selectedCategoryId ? undefined : (selectedCategory ?? undefined)),
            id_manufacturer: selectedManufacturer ?? undefined,
            product_group_id: selectedGroupQueryId ?? undefined,
            id_group: selectedGroupQueryId ? undefined : (selectedGroup ?? undefined),
            limit: limit,
        };

        fetchFn(params).then(data => {
            // cast mapped result to Product[] to ensure setList accepts it
            if (data && data.data && data.data.items) {
                setList(
                    data.data.items.map((item: any) => ({
                        id: item.id,
                        name: item.name,
                        unit: item.short_content,
                        image: item.avatar,
                        price: item.price,
                        promoPrice: item.promotion_product?.[0]?.promotion ? Math.round(item.price * (1 - item.promotion_product[0].percent / 100)) : undefined,
                        discount: item.discount ? `-${item.discount}%` : undefined,
                        sold: 0,
                        seller: "MEDX",
                        sellerLogo: "https://cdn-web-next.thuocsi.vn/icons/color_seller.svg",
                        quantity: 0,
                        liked: wishlistIds.includes(item.id),
                        bg: false,
                        slug: item.slug,
                    })) as Product[]
                );
                setTotalPage(data.data.total > 0 ? Math.ceil(data.data.total / limit) : 1);
            }
        });
    }, [page, SortValue, selectedCategory, selectedCategoryId, selectedManufacturer, selectedGroup, selectedGroupQueryId, category_slug, isLasted, isHighProfit, wishlistIds, limit]);

    return (
        <>
            <Helmet>
                <title>Dược Tâm Hạnh - Sản phẩm</title>
                <meta name="description" content="Khám phá danh mục sản phẩm đa dạng của Dược Tâm Hạnh, từ thuốc tây y, thực phẩm chức năng đến thiết bị y tế. Chất lượng đảm bảo, giá cả cạnh tranh, phục vụ tận tâm." />
            </Helmet>
            <div className="style_container__eyX8n">
                <div className="style_wrapperBreadCrumb__5V8CJ">
                    <nav
                        className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary"
                        aria-label="breadcrumb"
                    >
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">
                                    Trang chủ
                                </a>
                            </li>

                            <li
                                aria-hidden="true"
                                className="MuiBreadcrumbs-separator"
                                ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                </svg>
                            </li>

                            <li
                                className="MuiBreadcrumbs-li"
                                ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp"
                            >
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">
                                    Sản phẩm
                                </span>
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className="mb-4 hidden-1199">
                    <div className="styles_wrapper__7piYE">
                        {/* SCROLL LEFT */}
                        {canScrollLeft && (
                            <button
                                className="styles_scrollButton__9ompJ"
                                aria-label="Scroll left"
                                onClick={scrollLeft}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="12"
                                        transform="matrix(-1 0 0 1 24 0)"
                                        fill="#C1C8D1"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M14.8561 6.25105C15.1908 6.58579 15.1908 7.1285 14.8561 7.46323L10.3193 12L14.8561 16.5368C15.1908 16.8715 15.1908 17.4142 14.8561 17.7489C14.5214 18.0837 13.9786 18.0837 13.6439 17.7489L8.50105 12.6061C8.16632 12.2714 8.16632 11.7286 8.50105 11.3939L13.6439 6.25105C13.9786 5.91632 14.5214 5.91632 14.8561 6.25105Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        )}

                        {/* PRODUCT GROUP */}
                        <div className="styles_containerList__EB2bE scrollbar-0" onScroll={updateScrollState} ref={listRef}>
                            {/* ========== ALL PRODUCTS ========== */}
                            <div>
                                <div
                                    className={`styles_mobile_rootBase__8z7PQ styles_item__cI8YZ ${!selectedGroup ? "styles_activeItem__UI9iD" : ""} cursor-pointer`}
                                    onClick={() => handleSelectGroup(null)}
                                >
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "inline-block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: "0px",
                                                    margin: "0px",
                                                    padding: "0px",
                                                    position: "relative",
                                                    maxWidth: "100%"
                                                }}
                                            >
                                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'/%3e"
                                                        style={{
                                                            display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px"
                                                        }}
                                                    />
                                                </span>
                                                <img
                                                    alt="Tất Cả Sản Phẩm"
                                                    src="/theme/tatcasanpham_active.svg"
                                                    style={{
                                                        position: "absolute",
                                                        inset: "0px",
                                                        boxSizing: "border-box",
                                                        padding: "0px",
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: "0px",
                                                        height: "0px",
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <span>Tất Cả Sản Phẩm</span>
                                    </div>
                                </div>
                            </div>

                            {/* ========== DYNAMIC GROUPS ========== */}
                            {groups.map((group) => {
                                const isActive = selectedGroup === group.id
                                return (
                                    <div key={group.id}>
                                        <div
                                            className={`styles_mobile_rootBase__8z7PQ styles_item__cI8YZ ${isActive ? "styles_activeItem__UI9iD" : ""} cursor-pointer`}
                                            onClick={() => handleSelectGroup(isActive ? null : group.id)}
                                        >
                                            <div className="styles_wrapperContent__KcVAH">
                                                <div className="styles_iconWrapper__xq2Nj">
                                                    <img
                                                        alt={group.name}
                                                        src={group.avatar || ""}
                                                        style={{ width: 24, height: 24, objectFit: 'contain' }}
                                                    />
                                                </div>
                                                <span>{group.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {/* SCROLL RIGHT */}
                        {canScrollRight && (
                            <button
                                className="styles_scrollButton__9ompJ"
                                aria-label="Scroll right"
                                onClick={scrollRight}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="12" fill="#C1C8D1" />
                                    <path
                                        d="M16.1264 11.1743L11.0402 6.33027C10.8103 6.11009 10.523 6 10.1782 6C9.85249 6 9.57471 6.11009 9.34483 6.33027C9.11494 6.55046 9 6.81651 9 7.12844C9 7.44037 9.11494 7.70642 9.34483 7.92661L13.5977 12L9.34483 16.0459C9.11494 16.2661 9 16.5413 9 16.8716C9 17.1835 9.11494 17.4495 9.34483 17.6697C9.57471 17.8899 9.85249 18 10.1782 18C10.523 18 10.8103 17.8899 11.0402 17.6697L16.1264 12.8257C16.3755 12.6055 16.5 12.3303 16.5 12C16.5 11.6697 16.3755 11.3945 16.1264 11.1743Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>

                <div className="style_wrapper__bwV9H">
                    <div className="style_sidebar__l2b5C hidden-1199">
                        <div className="style_group__V1E_g">
                            <div>
                                <div className="styles_containerFilter___rtUq">
                                    <ProductGroupAccordion data={productGroup} setSelectedCategory={handleSelectCategory} />
                                </div>
                            </div>
                            {/* <hr className="style_hr__fnI3e" />
                            <div className="mt-4">
                                <div className="styles_containerFilter___rtUq">
                                    <ProductGroupListAccordion data={groups} setSelectedGroup={setSelectedGroup} />
                                </div>
                            </div> */}
                            <hr className="style_hr__fnI3e" />
                            <div className="mt-4">
                                <div className="styles_containerFilter___rtUq">
                                    <ManufacturerAccordion data={manufacturers} setSelectedManufacturer={setSelectedManufacturer} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="style_product_main__USHVn">
                        <div className="style_filterMobile__4vy1x show-1199 relative z-10">
                            <div className="style_filterSortRow__4D2kS">
                                <div className="style_filterButton__6xPq4" onClick={() => setShowFilter(true)}>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3.33333 14L3.33333 9.33333M3.33333 9.33333C4.06971 9.33333 4.66667 8.73638 4.66667 8C4.66667 7.26362 4.06971 6.66667 3.33333 6.66667M3.33333 9.33333C2.59695 9.33333 2 8.73638 2 8C2 7.26362 2.59695 6.66667 3.33333 6.66667M8 14V8M8 3.33333V2M8 3.33333C8.73638 3.33333 9.33333 3.93029 9.33333 4.66667C9.33333 5.40305 8.73638 6 8 6C7.26362 6 6.66667 5.40305 6.66667 4.66667C6.66667 3.93029 7.26362 3.33333 8 3.33333ZM3.33333 6.66667L3.33333 2M12.6667 8V2M12.6667 14V12.6667M12.6667 12.6667C13.403 12.6667 14 12.0697 14 11.3333C14 10.597 13.403 10 12.6667 10C11.9303 10 11.3333 10.597 11.3333 11.3333C11.3333 12.0697 11.9303 12.6667 12.6667 12.6667Z"
                                            stroke="#428c04"
                                            strokeLinecap="round"
                                        />
                                    </svg>

                                    <span className="style_btnText__DXTjV">Bộ lọc</span>
                                </div>

                                <div className="style_select__rqefc" ref={wrapperRef}>
                                    <span className="style_headSort__VGBNI">Sắp xếp</span>

                                    <div style={{ position: "relative" }}>
                                        <button
                                            className={
                                                "MuiButtonBase-root style_customButtonSelect__iI282" +
                                                (open ? " Mui-expanded" : "")
                                            }
                                            tabIndex={0}
                                            type="button"
                                            aria-controls="customized-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpen((v) => !v)
                                            }}
                                        >
                                            <span className="style_labelSort__JH4m1">{SORT_OPTIONS.find(item => item.value === SortValue)?.label}</span>

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.85795 13.2706C7.09014 13.2706 6.70624 14.3152 7.26465 14.9178L11.4178 19.6987C11.7319 20.1004 12.2554 20.1004 12.6044 19.6987L16.7575 14.9178C17.281 14.3152 16.8971 13.2706 16.1642 13.2706H7.85795ZM16.7575 9.05212L12.6044 4.27119C12.2554 3.9096 11.7319 3.9096 11.4178 4.27119L7.26465 9.05212C6.70624 9.69494 7.09014 10.6993 7.85795 10.6993H16.1642C16.8971 10.6993 17.281 9.69494 16.7575 9.05212Z"
                                                    fill="#1F1F1F"
                                                />
                                            </svg>

                                            <span className="MuiTouchRipple-root" />
                                        </button>

                                        {/* DROPDOWN */}
                                        {open && (
                                            <div className="MuiMenu-paper z-50 right-0 top-[110%] MuiPaper-root absolute MuiPaper-elevation0 MuiPaper-rounded min-w-[160px]">
                                                <ul className="jss275 bg-white MuiMenu-list MuiList-root MuiMenu-list jss274 MuiList-padding flex flex-col bg-white" role="menu" aria-labelledby="customized-menu">
                                                    {SORT_OPTIONS.map((item) => (
                                                        <li
                                                            key={item.value}
                                                            className={
                                                                "MuiButtonBase-root MuiListItem-root MuiMenuItem-root jss297 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" +
                                                                (SortValue === item.value ? " Mui-selected" : "")
                                                            }
                                                            onClick={() => {
                                                                setSortValue(item.value)
                                                                setOpen(false)
                                                            }}
                                                        >
                                                            {item.label}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="style_product_grid_wrapper__lYnBj">
                            <div className="style_sort___U0J9">
                                <div className="style_hiddenContainer__3MwzR">
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                                        <div className="MuiBox-root css-1dtnjt5">
                                            <label
                                                className="MuiFormControlLabel-root sc-5bd16284-0 cuEQuH style_textHidden__kn0HQ flex items-center" onClick={toggle}
                                            >
                                                <span
                                                    className={
                                                        "MuiButtonBase-root MuiIconButton-root jss8 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary" +
                                                        (checked ? " Mui-checked" : "")
                                                    }
                                                    aria-disabled="false"
                                                >
                                                    <span className="MuiIconButton-label">
                                                        <input
                                                            className="jss11"
                                                            name="filter-out-of-stock"
                                                            type="checkbox"
                                                            data-indeterminate="false"
                                                            value=""
                                                        />
                                                        {checked ?
                                                            <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                                            :
                                                            <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></svg>
                                                        }
                                                    </span>

                                                    <span className="MuiTouchRipple-root" />
                                                </span>

                                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1 !leading-[1.5] !m-0 !p-0 !h-[39px] !flex !items-center whitespace-nowrap">
                                                    {checked ? "Đã Ẩn Sản Phẩm Hết Hàng" : "Ẩn Sản Phẩm Hết Hàng"}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="style_topPagging__fUaNu">
                                    <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                                        <nav
                                            aria-label="pagination navigation"
                                            className="MuiPagination-root jss273"
                                        >
                                            <ul className="MuiPagination-ul">
                                                {/* PREV */}
                                                <li>
                                                    <button
                                                        className={
                                                            "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                            (page === 1 ? " Mui-disabled" : "")
                                                        }
                                                        tabIndex={page === 1 ? -1 : 0}
                                                        type="button"
                                                        disabled={page === 1}
                                                        aria-label="Go to previous page"
                                                        onClick={goPrev}
                                                    >
                                                        <svg
                                                            className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                            focusable="false"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                        </svg>
                                                    </button>
                                                </li>

                                                {/* PAGE NUMBERS */}
                                                {getPages().map((p, i) => {
                                                    if (p === "...") {
                                                        return (
                                                            <li key={`ellipsis-${i}`}>
                                                                <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                                                    …
                                                                </div>
                                                            </li>
                                                        )
                                                    }
                                                    return (
                                                        <li key={p}>
                                                            <button
                                                                className={
                                                                    "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                                    (page === p ? " Mui-selected" : "")
                                                                }
                                                                tabIndex={0}
                                                                type="button"
                                                                aria-current={page === p ? "true" : undefined}
                                                                aria-label={`Go to page ${p}`}
                                                                onClick={() => setPage(Number(p))}
                                                            >
                                                                {p}
                                                                <span className="MuiTouchRipple-root" />
                                                            </button>
                                                        </li>
                                                    )
                                                })}

                                                {/* NEXT */}
                                                <li>
                                                    <button
                                                        className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                                        tabIndex={0}
                                                        type="button"
                                                        aria-label="Go to next page"
                                                        onClick={goNext}
                                                    >
                                                        <svg
                                                            className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                            focusable="false"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                                        </svg>
                                                        <span className="MuiTouchRipple-root" />
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>

                                <div className="style_select__rqefc hidden-1199" ref={wrapperRef}>
                                    <span className="style_headSort__VGBNI">Sắp xếp</span>

                                    <div style={{ position: "relative" }}>
                                        <button
                                            className={
                                                "MuiButtonBase-root style_customButtonSelect__iI282" +
                                                (open ? " Mui-expanded" : "")
                                            }
                                            tabIndex={0}
                                            type="button"
                                            aria-controls="customized-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpen((v) => !v)
                                            }}
                                        >
                                            <span className="style_labelSort__JH4m1">{SORT_OPTIONS.find(item => item.value === SortValue)?.label}</span>

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.85795 13.2706C7.09014 13.2706 6.70624 14.3152 7.26465 14.9178L11.4178 19.6987C11.7319 20.1004 12.2554 20.1004 12.6044 19.6987L16.7575 14.9178C17.281 14.3152 16.8971 13.2706 16.1642 13.2706H7.85795ZM16.7575 9.05212L12.6044 4.27119C12.2554 3.9096 11.7319 3.9096 11.4178 4.27119L7.26465 9.05212C6.70624 9.69494 7.09014 10.6993 7.85795 10.6993H16.1642C16.8971 10.6993 17.281 9.69494 16.7575 9.05212Z"
                                                    fill="#1F1F1F"
                                                />
                                            </svg>

                                            <span className="MuiTouchRipple-root" />
                                        </button>

                                        {/* DROPDOWN */}
                                        {open && (
                                            <div className="MuiMenu-paper z-50 right-0 top-[110%] MuiPaper-root absolute MuiPaper-elevation0 MuiPaper-rounded min-w-[160px]">
                                                <ul className="jss275 bg-white MuiMenu-list MuiList-root MuiMenu-list jss274 MuiList-padding flex flex-col" role="menu" aria-labelledby="customized-menu">
                                                    {SORT_OPTIONS.map((item) => (
                                                        <li
                                                            key={item.value}
                                                            className={
                                                                "MuiButtonBase-root MuiListItem-root MuiMenuItem-root jss297 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" +
                                                                (SortValue === item.value ? " Mui-selected" : "")
                                                            }
                                                            onClick={() => {
                                                                setSortValue(item.value)
                                                                setOpen(false)
                                                            }}
                                                        >
                                                            {item.label}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: "8px 0px", fontStyle: "italic", color: "rgb(245, 34, 45)" }}>*Giá bạn đang xem là giá đã giảm sau khi áp dụng các chương trình khuyến mãi như chiết khấu chuyển khoản và mã giảm giá</div>
                        <ProductsList data={list} />
                        <div className="style_bottomPagging__kzl7h">
                            <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                                <nav
                                    aria-label="pagination navigation"
                                    className="MuiPagination-root jss273"
                                >
                                    <ul className="MuiPagination-ul">
                                        {/* PREV */}
                                        <li>
                                            <button
                                                className={
                                                    "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                    (page === 1 ? " Mui-disabled" : "")
                                                }
                                                tabIndex={page === 1 ? -1 : 0}
                                                type="button"
                                                disabled={page === 1}
                                                aria-label="Go to previous page"
                                                onClick={goPrev}
                                            >
                                                <svg
                                                    className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                </svg>
                                            </button>
                                        </li>

                                        {/* PAGE NUMBERS */}
                                        {getPages().map((p, i) => {
                                            if (p === "...") {
                                                return (
                                                    <li key={`ellipsis-bottom-${i}`}>
                                                        <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                                            …
                                                        </div>
                                                    </li>
                                                )
                                            }
                                            return (
                                                <li key={p}>
                                                    <button
                                                        className={
                                                            "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                            (page === p ? " Mui-selected" : "")
                                                        }
                                                        tabIndex={0}
                                                        type="button"
                                                        aria-current={page === p ? "true" : undefined}
                                                        aria-label={`Go to page ${p}`}
                                                        onClick={() => setPage(Number(p))}
                                                    >
                                                        {p}
                                                        <span className="MuiTouchRipple-root" />
                                                    </button>
                                                </li>
                                            )
                                        })}

                                        {/* NEXT */}
                                        <li>
                                            <button
                                                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                                tabIndex={0}
                                                type="button"
                                                aria-label="Go to next page"
                                                onClick={goNext}
                                            >
                                                <svg
                                                    className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                                </svg>
                                                <span className="MuiTouchRipple-root" />
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>

                <RecommendationList />
            </div>
            <FilterMobileDialog
                open={showFilter}
                onClose={() => setShowFilter(false)}
                productGroup={productGroup}
                manufacturers={manufacturers}
                groups={groups}
                selectedCategory={selectedCategory}
                selectedManufacturer={selectedManufacturer}
                selectedGroup={selectedGroup}
                onSelectCategory={handleSelectCategory}
                onSelectManufacturer={setSelectedManufacturer}
                onSelectGroup={handleSelectGroup}
            />
        </>
    )
}
